import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Tabs from './../Tabs';
import Intersection from './../Intersection';
import {
  getInitalSearchResults,
  performSearch,
  setUrlParams,
} from './../../slices/appSlice';
import queryString from 'query-string';
import history from 'history/browser';

function App() {
  const dispatch = useDispatch();
  const {
    lists,
    selectedIndex,
  } = useSelector((state) => state.app);
  const inViewHelper = useRef(new Array(lists.length).fill([1]));
  const currentParams = queryString.parse(history.location.search);
  const { pages = [], urlParams = {}, loading = false, maxPages = 1, id, banner = [] } = lists[selectedIndex];
  const [currentPage, setCurrentPage] = useState(1);
  const [hasScrolled, setHasScrolled] = useState(!currentParams['page']);

  const handleInViewChange = ({ inView, page }) => {
    const iof = inViewHelper.current[selectedIndex].indexOf(page);

    if (iof === -1 && inView === true) {
      inViewHelper.current[selectedIndex].unshift(page);
      if (inViewHelper.current[selectedIndex].length > 2) {
        inViewHelper.current[selectedIndex].length = 2;
      }
    } else if (iof > -1 && inView === false) {
      inViewHelper.current[selectedIndex].splice(iof, 1);
    }
    if (inViewHelper.current[selectedIndex].length > 0) {
      const currentPage = Math.min.apply(
        null,
        inViewHelper.current[selectedIndex],
      );

      if (currentPage > 0) {
        if (maxPages >= currentPage) {
          dispatch(setUrlParams({ remove: currentPage === 1, get: { page: currentPage } }));
          setCurrentPage(currentPage);
        }
      }
    }
  };

  const focusFirstCardInNewPage = (id, page) => {
    const pageEle = document.getElementById(`product-listing-${id}-page-${page}`);

    if (!pageEle) {
      return;
    }

    // Use a slightly longer timeout to ensure the DOM is fully rendered
    // Consider using requestAnimationFrame for better performance
    window.requestAnimationFrame(() => {
      const cardEle = pageEle.querySelector('ft-card');

      if (!cardEle) {
        return;
      }

      const shadowRoot = cardEle.shadowRoot;
      if (!shadowRoot) {
        return;
      }

      const targetElement = shadowRoot.querySelector('a');
      if (!targetElement) {
        return;
      }

      // Focus the element
      try {
        targetElement.focus({ focusVisible: true });
      } catch (error) {
        console.error('Error focusing element:', error);
      }
    });
  };

  useEffect(() => {
    if (currentParams['page']) {
      const pageEle = document.getElementById('product-listing-' + id + '-page-' + currentParams['page']);
      if (pageEle && !hasScrolled) {
        pageEle.scrollIntoView(false);
        setHasScrolled(true);
      }
    }
  }, [pages]);

  const bannerPositions = [
    { pos: 5, c: 'banner col-span-full tablet:hidden' },
    { pos: 7, c: 'banner col-span-full hidden tablet:block laptop:hidden' },
    { pos: 9, c: 'banner col-span-full hidden laptop:block' },
  ];

  return (
    <ft-section spacing="none" width="full">
      <Tabs {...{ lists, selectedIndex, maxPages, currentPage: pages.length, listId: id, focusFirstCardInNewPage }}>
        <ft-section content-padding="none">
          <div className="container container-default pt-5xl pb-5xl">
            {
              pages.map((page, p) => {
                const pageBanner = banner[p];

                return (
                  <Intersection key={`${p}`}
                                page={p + 1} {...{ handleInViewChange, listId: id }}>
                    {
                      page.map(({ _source: { teaser } }, r) => {
                        const bannerOptions = bannerPositions.find(({ pos }) => r+1 === pos);
                        return (
                          <React.Fragment key={`${p}${r}`}>
                            <If condition={pageBanner && bannerOptions}>
                              <div key={`b-${p}`} className={bannerOptions.c}>
                                <Choose>
                                  <When condition={pageBanner.url}>
                                    <a href={pageBanner.url}>
                                      <picture>
                                        <source
                                          srcSet={pageBanner.desktop_image_path}
                                          media="(min-width: 640px)"
                                        />
                                        <img
                                          src={pageBanner.mobile_image_path}
                                          alt={pageBanner.mobile_image_alt}
                                        />
                                      </picture>
                                    </a>
                                  </When>
                                  <Otherwise>
                                    <picture>
                                      <source
                                        srcset={pageBanner.desktop_image_path}
                                        media="(min-width: 640px)"
                                      />
                                      <img
                                        src={pageBanner.mobile_image_path}
                                        alt={pageBanner.mobile_image_alt}
                                      />
                                    </picture>
                                  </Otherwise>
                                </Choose>
                              </div>
                            </If>
                            <div dangerouslySetInnerHTML={{__html: teaser}}></div>
                          </React.Fragment>
                        );
                      })
                    }
                  </Intersection>
                );
              })
            }
            <div className="flex justify-center my-sm">
              <If condition={loading}>
                <ft-spinner className="absolute left-1/2"></ft-spinner>
              </If>
              <If condition={!loading && pages.length < maxPages}>
                <ft-button onClick={() => {
                  const page = pages.length + 1;
                  dispatch(performSearch({ page })).then(() => {
                    focusFirstCardInNewPage(id, page)
                  });
                }
                }>{Drupal.t('Load more')}</ft-button>
              </If>
            </div>
          </div>
        </ft-section>
      </Tabs>
    </ft-section>
  );
}

export default App;
